"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTransaction = void 0;
const invariant_1 = __importDefault(require("invariant"));
const stellar_sdk_1 = __importDefault(require("stellar-sdk"));
const errors_1 = require("@ledgerhq/errors");
const api_1 = require("./api");
const logic_1 = require("./logic");
const errors_2 = require("../../errors");
/**
 * @param {Account} a
 * @param {Transaction} t
 */
const buildTransaction = (account, transaction) => __awaiter(void 0, void 0, void 0, function* () {
    const { recipient, networkInfo, fees, memoType, memoValue, mode, assetCode, assetIssuer } = transaction;
    if (!fees) {
        throw new errors_1.FeeNotLoaded();
    }
    const source = yield (0, api_1.loadAccount)(account.freshAddress);
    if (!source) {
        throw new errors_1.NetworkDown();
    }
    (0, invariant_1.default)(networkInfo && networkInfo.family === "stellar", "stellar family");
    const transactionBuilder = (0, api_1.buildTransactionBuilder)(source, fees);
    let operation = null;
    if (mode === "changeTrust") {
        if (!assetCode || !assetIssuer) {
            throw new errors_2.StellarAssetRequired("");
        }
        operation = (0, api_1.buildChangeTrustOperation)(assetCode, assetIssuer);
    }
    else {
        // Payment
        const amount = (0, logic_1.getAmountValue)(account, transaction, fees);
        if (!amount) {
            throw new errors_1.AmountRequired();
        }
        const recipientAccount = yield (0, logic_1.getRecipientAccount)({
            account,
            recipient: transaction.recipient,
        });
        if (recipientAccount === null || recipientAccount === void 0 ? void 0 : recipientAccount.id) {
            operation = (0, api_1.buildPaymentOperation)({
                destination: recipient,
                amount,
                assetCode,
                assetIssuer,
            });
        }
        else {
            if (recipientAccount === null || recipientAccount === void 0 ? void 0 : recipientAccount.isMuxedAccount) {
                throw new errors_2.StellarMuxedAccountNotExist("");
            }
            operation = (0, api_1.buildCreateAccountOperation)(recipient, amount);
        }
    }
    transactionBuilder.addOperation(operation);
    let memo = null;
    if (memoType && memoValue) {
        switch (memoType) {
            case "MEMO_TEXT":
                memo = stellar_sdk_1.default.Memo.text(memoValue);
                break;
            case "MEMO_ID":
                memo = stellar_sdk_1.default.Memo.id(memoValue);
                break;
            case "MEMO_HASH":
                memo = stellar_sdk_1.default.Memo.hash(memoValue);
                break;
            case "MEMO_RETURN":
                memo = stellar_sdk_1.default.Memo.return(memoValue);
                break;
        }
    }
    if (memo) {
        transactionBuilder.addMemo(memo);
    }
    const built = transactionBuilder.setTimeout(0).build();
    return built;
});
exports.buildTransaction = buildTransaction;
exports.default = exports.buildTransaction;
//# sourceMappingURL=js-buildTransaction.js.map